import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { generatePath, useSearchParams } from 'react-router';

import { useTypedParams } from '@sorare/routing';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import { FOOTBALL_ONBOARDING_LEADERBOARD_RECOMMENDED_PLAYERS } from '@sorare/core/src/constants/__generated__/routes';
import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import { FirstLineup } from '#src/components/onboarding/FirstLineup/index.tsx';

import type {
  getCartQuery,
  getCartQueryVariables,
} from './__generated__/page.graphql.ts';
import type { PageParams } from './__generated__/routeParams.ts';

const GET_CART_QUERY = gql`
  query getCartQuery($sport: Sport!, $slug: String!) {
    currentUser {
      slug
      ...FirstLineup_currentUser
    }
    so5 {
      so5Leaderboard(slug: $slug) {
        slug
        id
        ...FirstLineup_so5Leaderboard
      }
    }
  }
  ${FirstLineup.fragments.currentUser}
  ${FirstLineup.fragments.so5Leaderboard}
` as TypedDocumentNode<getCartQuery, getCartQueryVariables>;

const FirstLineupPage = () => {
  const { leaderboard } = useTypedParams<PageParams>();
  const [searchParams] = useSearchParams();
  const teamSlugsParam = searchParams.get('teamSlugs');
  const {
    data,
    refetch,
    loading: cartQueryLoading,
  } = useQuery(GET_CART_QUERY, {
    variables: {
      slug: leaderboard ?? '',
      sport: Sport.FOOTBALL,
    },
  });

  const { currentUser, so5 } = data ?? {};
  const { so5Leaderboard } = so5 ?? {};

  if (!data) {
    return <LoadingIndicator fullScreen />;
  }

  return (
    <FirstLineup
      currentUser={currentUser}
      so5Leaderboard={so5Leaderboard}
      refetch={refetch}
      cartQueryLoading={cartQueryLoading}
      backUrl={`${generatePath(
        FOOTBALL_ONBOARDING_LEADERBOARD_RECOMMENDED_PLAYERS,
        {
          leaderboard,
        }
      )}?teamSlugs=${teamSlugsParam}`}
    />
  );
};

export default FirstLineupPage;
